import React, {useEffect, useState} from "react";
import {Alert, Button, Col, FormGroup, Input, Label, Row, Modal} from "reactstrap";

function GoogleMapPolygon(props) {

    const { idBoxMap } = props;

    // Maps Static API を使用してマップ画像を生成
    const apiKey = 'AIzaSyB-B-aVopZHua54Rime3wFIUJp2gCUsmmM';
    const optionsMap = {
        center: {
            lat: 35.68370098971363,
            lng: 139.7004348630834
        },
        zoom: 18,
        gestureHandling: "greedy"
    }

    // option select attr
    const listSelectedColor = [
        {
            label: '黒色',
            value: '#000000',
        },
        {
            label: '赤色',
            value: '#ff0000',
        },
        {
            label: 'オリーブ色',
            value: '#808000',
        },
        {
            label: '黄色',
            value: '#FFFF00',
        },
        {
            label: '青色',
            value: '#0000FF',
        }
    ];
    const listSelectWeight = [
        {
            label: '0',
            value: '0',
        },
        {
            label: '5',
            value: '5',
        },
        {
            label: '10',
            value: '10',
        },
        {
            label: '15',
            value: '15',
        },
        {
            label: '20',
            value: '20',
        },
        {
            label: '25',
            value: '25',
        },
        {
            label: '30',
            value: '30',
        },
        {
            label: '35',
            value: '35',
        },
        {
            label: '40',
            value: '40',
        },
    ];
    const listSelectOpacity = [
        {
            label: '0',
            value: '0',
        },
        {
            label: '0.2',
            value: '0.2',
        },
        {
            label: '0.4',
            value: '0.4',
        },
        {
            label: '0.6',
            value: '0.6',
        },
        {
            label: '0.8',
            value: '0.8',
        },
        {
            label: '1',
            value: '1',
        },
    ];

    // memo list
    const [isMemoList, setMemoList] = useState([
        {
            title: 'メモを入力してください 1',
            lat: 35.683772765981,
            lng: 139.6991517473873
        },
        {
            title: 'メモを入力してください 2',
            lat: 35.683612,
            lng: 139.699510
        },
        {
            title: 'メモを入力してください 3',
            lat: 35.683368,
            lng: 139.699596
        },
    ]);

    const [isModal, setModal] = useState(false)
    const [isEditStyles, setEditStyles] = useState("")
    useEffect(()=>{
        console.log("modalChange");
    },[isModal])
    const createGoogleStaticMapUrl = () => {
        const center = isLoadMapInt? {lat:isLoadMapInt.getCenter().lat(),lng:isLoadMapInt.getCenter().lng()}: optionsMap.center
        let zoom = isLoadMapInt?isLoadMapInt.getZoom(): 18
        let styles = "&zoom="+ zoom+ "&size=500x500"
        styles = styles += "&center="+center.lat + "," + center.lng
        styles = styles += "&style=feature:poi|element:labels.icon|visibility:off"
        styles = styles += "&style=feature:landscape|element:labels.icon|visibility:off"
        styles = styles += "&style=featurel:poi.park|element:labels.text.stroke|color:white"
        styles = styles += "&style=featurel:poi.park|element:labels.text.fill|color:black"
        styles = styles += "&style=feature:transit.line|element|labels.icon|visibility:off"
        styles = styles += "&style=feature:all|element:geometry.stroke|color:0x999999"
        styles = styles += "&style=feature:road|element:labels.icon|saturation:-100"
        styles = styles += "&style=feature:transit|element:labels.icon|saturation:-100"
        styles = styles += isEditStyles
        isMapStyles.forEach((s)=>{
            styles = styles + "&style=feature:"+s.feature
            styles = styles + "|element:"+s.element
            Object.keys(s.params).forEach ((k)=>{
                let setP = s.params[k]
                if (k == "color"||k == "hue") {
                    setP = setP.replace("#","0x") 
                } 
                styles = styles + `|${k}:${setP}`
            })
        })
        return "https://maps.googleapis.com/maps/api/staticmap?key=" + apiKey + styles
    }
    const [isMapStyles, setMapStyles] = useState([
        /* 基本的な書き方
        {
            feature: "administrative.land_parcel", 
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
                weight : "",
                invert_lightness : "" ,
            } 
        },
        */
        {
            feature: "all", // 土地区間
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
/*
        {
            feature: "administrative.land_parcel", // 
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
//                lightness : -100,
//                saturation : -100,
//                gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "administrative.land_parcel", // 土地区間
            element: "geometry.stroke",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "administrative.locality", // 地域
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#EEEEEE",
            } 
        },
        {
            feature: "administrative.locality", // 地域
            element: "geometry.stroke",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#EEEEEE",
            } 
        },
        {
            feature: "administrative.neighborhood", // 近隣
            element: "geometry.fill",
            params : {
                hue : "#AAAAAA",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#AAAAAA",
            } 
        },
        {
            feature: "administrative.neighborhood", // 近隣
            element: "geometry.stroke",
            params : {
                hue : "#AAAAAA",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#AAAAAA",
            } 
        },
        {
            feature: "administrative.province", // 州
            element: "geometry.fill",
            params : {
                hue : "#DDDDDD",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#DDDDDD",
            } 
        },
        {
            feature: "administrative.province", // 州
            element: "geometry.stroke",
            params : {
                hue : "#DDDDDD",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#DDDDDD",
            } 
        },
*/
        {
            feature: "landscape.man_made", // 建物やその他の構造物などの人工の特徴
            element: "geometry.fill",
            params : {
                hue : "#F5F5F5",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#F5F5F5",
            } 
        },
        {
            feature: "landscape.man_made", // 建物やその他の構造物などの人工の特徴
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "landscape.natural", // 山、川、砂漠、氷河などの自然の特徴
            element: "geometry.fill",
            params : {
                hue : "#CCCCCC",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#CCCCCC",
            } 
        },
        {
            feature: "landscape.natural", // 山、川、砂漠、氷河などの自然の特徴
            element: "geometry.stroke",
            params : {
                hue : "#555555",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#555555",
                weight : 2,
            } 
        },
        {
            feature: "landscape.natural.landcover", // 土地被覆フィーチャ、つまり森林、草地、湿地、裸地などの地表を覆う物理的なマテリアル
            element: "geometry.fill",
            params : {
                hue : "#666666",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#666666",
            } 
        },
        {
            feature: "landscape.natural.landcover", // 土地被覆フィーチャ、つまり森林、草地、湿地、裸地などの地表を覆う物理的なマテリアル
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 2,
            } 
        },
        {
            feature: "poi.attraction", // 観光名所
            element: "geometry.fill",
            params : {
                hue : "#DDDDDD",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#DDDDDD",
            } 
        },
        {
            feature: "poi.attraction", // 観光名所
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.business", // ビジネス
            element: "geometry.fill",
            params : {
                hue : "#DDDDDD",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#DDDDDD",
            } 
        },
        {
            feature: "poi.business", //  ビジネス
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.government", // 国の建物
            element: "geometry.fill",
            params : {
                hue : "#AAAAAA",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#AAAAAA",
            } 
        },
        {
            feature: "poi.government", // 国の建物
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.medical", // 病院、薬局、警察、医師などを含む救急サービス
            element: "geometry.fill",
            params : {
                hue : "#DDDDDD",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#DDDDDD",
            } 
        },
        {
            feature: "poi.medical", // 病院、薬局、警察、医師などを含む救急サービス
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.park", // 公園
            element: "geometry.fill",
            params : {
                hue : "#EEEEEE",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#EEEEEE",
            } 
        },
        {
            feature: "poi.park", // 公園
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.place_of_worship", // 教会、神殿、モスクなどを含む礼拝所
            element: "geometry.fill",
            params : {
                hue : "#EEEEEE",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#EEEEEE",
            } 
        },
        {
            feature: "poi.place_of_worship", // 教会、神殿、モスクなどを含む礼拝所
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.school", // 学校
            element: "geometry.fill",
            params : {
                hue : "#EEEEEE",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#EEEEEE",
            } 
        },
        {
            feature: "poi.school", // 学校
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "poi.sports_complex", // スポーツコンプレックス
            element: "geometry.fill",
            params : {
                hue : "#EEEEEE",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#EEEEEE",
            } 
        },
        {
            feature: "poi.sports_complex", // スポーツコンプレックス
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "road.arterial", // 幹線道路
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "road.arterial", // 幹線道路
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "road.highway", // 高速道路
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "road.highway", //  高速道路
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "road.highway.controlled_access", // アクセスが制御された高速道路
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "road.highway.controlled_access", // アクセスが制御された高速道路
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "road.local", // 地方道路
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "road.local", // 地方道路
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "transit.line", // トランジットライン
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "transit.line", //  トランジットライン
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
        {
            feature: "transit.station", //すべてのトランジットステーション　駅、空港、バス停
            element: "geometry.fill",
            params : {
                hue : "#FFFFFF",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#FFFFFF",
            } 
        },
        {
            feature: "transit.station", // すべてのトランジットステーション　駅、空港、バス停
            element: "geometry.stroke",
            params : {
                hue : "#000000",
               // lightness : -100,
                //saturation : -100,
                //gamma : 0.01,
                color : "#000000",
                weight : 1,
            } 
        },
    ])

    useEffect(()=>{

    },[isMapStyles])

    /* グーグルマップAPIを呼び出す */
    useEffect(() => {
        let isMounted = true;

        if ( isMounted ) {
            if (window.google) {
                onScriptLoad();
                onLoadMapParkingDetail();
                return;
            }

            let s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=drawing&v=weekly&channel=2`;
            let x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);

            s.addEventListener('load', () => {
                onScriptLoad();
                onLoadMapParkingDetail();
            });
        }

        return () => { isMounted = false };
    }, []);

    /* マップを初期化します */
    const [isLoadMapInt, setLoadMapInt] = useState();
    const onScriptLoad = () => {
        console.log("onScriptLoad");

        const mapId = document.getElementById(idBoxMap);
        const map = new window.google.maps.Map(mapId, optionsMap);
        const infoWindow = new window.google.maps.InfoWindow();

        polygon(map);
        marker_1(map);
        listMarkerBeachFlag(map);
        // onDrawingManager(map);
        onDirections(map);

        // set state load map
        setLoadMapInt(map);

        handleLocationError(false, infoWindow, map.getCenter());
    }

    //初期表示のポリゴン（枠線）の処理
    const [isPolygons, setPolygons] = useState([]);
    const [isPolygonMarker, setPolygonMarker] = useState([]);
    const polygon = (map) => {
        const polygonMarker = new window.google.maps.Polygon({
            map: map,
            paths: [
                new window.google.maps.LatLng(35.683725901073245, 139.7003790669471),
                new window.google.maps.LatLng(35.68366224248981, 139.70043728702308),
                new window.google.maps.LatLng(35.683702256462475, 139.70049998556638),
                new window.google.maps.LatLng(35.68376591501395, 139.7004283300883),
            ],
            draggable: true,
            editable: true,
            strokeColor: "#5a03fc",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "##03fc6f",
            fillOpacity: 0.35,
        });

        let polygonArrayInti = [];
        // 初期表示ポリゴン移動時にmarkerArrayInti変数格納
        window.google.maps.event.addListener(polygonMarker, "dragend", function() {
            polygonMarker.getPath().forEach((LatLng) => {
                polygonArrayInti.push(LatLng);
            });
        });

        setPolygons(oldArray => [...oldArray, polygonArrayInti]);
        setPolygonMarker(oldArray => [...oldArray, polygonMarker]);
    }

    //マーカーの定義
    const [isMarkerSrc, setMarkerSrc] = useState("35.68370098971363,139.7004348630834");
    const marker_1 = (map) => {
        const myLatLng = { lat: optionsMap.center.lat, lng: optionsMap.center.lng };

        const markerFirst =  new window.google.maps.Marker({
            position: myLatLng,
            draggable: true,
            map,
        });

        // 初期マーカー移動時にmarkerArrayInti変数格納
        window.google.maps.event.addListener(markerFirst, "dragend", function(ev) {
            let markerInti_1_1 = this.getPosition().lat(ev);
            markerInti_1_1 = markerInti_1_1 + "," + this.getPosition().lng(ev);
            markerInti_1 = "";
            setMarkerSrc(markerInti_1_1);
        });
    }

    /*
    ** マーカーの定義
    * */
    const [isMarkersMemo, setMarkersMemo] = useState([]);
    const listMarkerBeachFlag = (map) => {
        const listIsMarkersMemo = [...isMarkersMemo];

        isMemoList.map((item, index) => {
            const infoWindow = new window.google.maps.InfoWindow();
            const lat = item.lat;
            const lng = item.lng;

            const marker = new window.google.maps.Marker({
                position: new window.google.maps.LatLng(lat, lng),
                draggable: true,
                map,
                icon: new window.google.maps.MarkerImage(
                    "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
                    new window.google.maps.Size(100, 100),
                    new window.google.maps.Point(0, 0),
                    new window.google.maps.Point(0, 33)
                ),
            });

            infoWindow.setContent(item.title);

            infoWindow.open({
                anchor: marker,
                map,
                shouldFocus: false,
            });

            listIsMarkersMemo[index] = marker;
        });

        setMarkersMemo(listIsMarkersMemo);
    }

    // event dragend markers beach flag
    useEffect(() => {
        let isMounted = true;

        if ( isMounted && isMarkersMemo.length ) {

            isMarkersMemo.map((item, index) => {
                window.google.maps.event.addListener(item, "dragend", function(ev) {
                    const memoListArr = [...isMemoList];
                    const lat = this.getPosition().lat(ev);
                    const lng = this.getPosition().lng(ev);

                    memoListArr[index].lat = lat;
                    memoListArr[index].lng = lng;

                    // set new lat lang memo
                    setMemoList(memoListArr);
                });
            })

        }

        return () => { isMounted = false };
    },[isMarkersMemo]);

    // event edit memo
    const onChangeMarkerMemo = (index, title, lat, lng, map) => {
        isMarkersMemo[index].setMap(null);

        const infoWindow = new window.google.maps.InfoWindow({
            content: title,
        });

        const marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(lat, lng),
            //ドラックを許可
            draggable: true,
            map,
            //フォーカス時の表示タイトル
            // title: "mapCenter (Ayers Rock)",
            icon: new window.google.maps.MarkerImage(
                "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png", //マーカー画像URL
                new window.google.maps.Size(100, 100), //マーカー画像のサイズ
                new window.google.maps.Point(0, 0), //マーカー画像表示の起点（変更しない）
                new window.google.maps.Point(0, 33) //マーカー位置の調整
            ),
        });

        infoWindow.open({
            anchor: marker,
            map,
            shouldFocus: false,
        });

        const markerMemoItem = [...isMarkersMemo];

        markerMemoItem[index] = marker;
        setMarkersMemo(markerMemoItem);
    }

    // --------------------------------------------------------------------------------
    // 地図にマーカー、区画を追加するモードの切り替え
    // --------------------------------------------------------------------------------
    const MODE_GRAB = 0;
    const MODE_MARKER = 1;
    const MODE_POLYGON = 2;
    const [isShapeType, setShapeType] = useState(MODE_GRAB);
    const [isDisabledAddPolygon, setDisabledAddPolygon] = useState(true);
    const [lands, setLands] = useState([
        {
            instance: null,
            origin: null
        }
    ]);

    const [landIndex, setLandIndex] = useState(0);

    // event change shape type
    const onChangeShapeType = (e) => {
        const value = parseInt(e.target.value);
        setShapeType(value);

        // remove event listener
        window.google.maps.event.removeListener(isListenerDrawingManager);

        // type polygon
        if ( value === MODE_POLYGON ) {
            setDisabledAddPolygon(false);

            lands.map((l) => {
                if ( l.instance ) {
                    l.instance.setEditable(true);
                    l.instance.setDraggable(true);
                }
            });

        } else {
            setDisabledAddPolygon(true);

            lands.map((l) => {
                if ( l.instance ) {
                    l.instance.setEditable(false);
                    l.instance.setDraggable(false);
                }
            });
        }

        // type marker
        if ( value === MODE_MARKER ) {
            isDrawingManagerMarkers.map((item) => {
                item.setOptions({ draggable: true })
            })
        } else {
            isDrawingManagerMarkers.map((item) => {
                item.setOptions({ draggable: false })
            })
        }
    }
    const [isListenerDrawingManager, setListenerDrawingManager] = useState();
    useEffect(() => {
        let isMounted = true;

        if ( isMounted ) {
            let listener;

            if ( isShapeType === MODE_POLYGON ) {
                // マーカー、区画を追加するイベントトリガー
                listener = window.google.maps.event.addListener(isLoadMapInt, "click", (eMap) => polygonEventHandler(eMap) );
            } else if ( isShapeType === MODE_MARKER ) {
                // マーカー、区画を追加するイベントトリガー
                listener = window.google.maps.event.addListener(isLoadMapInt, "click", (eMap) => markerEventHandler(eMap) );
            }

            setListenerDrawingManager(listener);
        }

        return () => { isMounted = false };
    }, [isShapeType])

    // event drawing polygon
    const polygonEventHandler = (eMap) => {
        const latLng = { lat: eMap.latLng.lat(), lng: eMap.latLng.lng() };
        const coords = [];
        if (lands[landIndex].instance != null) {
            const landItem = lands[landIndex].instance;
            const vertices = landItem.getPath();

            // 更新
            for (let i = 0; i < vertices.getLength(); i++) {
                const vertex = vertices.getAt(i);

                coords.push({ lat: vertex.lat(), lng: vertex.lng() })
            }

            coords.push(latLng);
            landItem.setPath(coords);

        } else {
            coords.push(latLng);

            lands[landIndex].instance = new window.google.maps.Polygon({
                paths: coords,
                draggable: true,
                editable: true,
                strokeColor: "#5a03fc",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "##03fc6f",
                fillOpacity: 0.35,
            });

            lands[landIndex].instance.setMap(isLoadMapInt);
            lands[landIndex].origin = latLng;
        }

    }

    // event click and polygon
    const onClickAddPolygon = () => {
        // 選択していない区画の色を更新する
        lands.map((land) => {
            if ( land.instance ) {
                land.instance.setOptions({ strokeColor: "#00FF00" });
            }
        });

        if ( lands[lands.length - 1].instance ) {
            setLandIndex(lands.length);
        }
    }

    // call back drawing polygon
    const [isCallBackPolygonEventHandler, setCallBackPolygonEventHandler] = useState(false);
    useEffect(() => {
        let isMounted = true;

        if ( isMounted && landIndex > 0 ) {
            window.google.maps.event.removeListener(isListenerDrawingManager);

            setLands(oldArray => [...oldArray, {
                instance: null,
                origin: null
            }]);

            setCallBackPolygonEventHandler(true);
        }

        return () => { isMounted = false };
    }, [landIndex])

    useEffect(() => {
        let isMounted = true;

        if ( isMounted && isCallBackPolygonEventHandler ) {
            setListenerDrawingManager( window.google.maps.event.addListener(isLoadMapInt, "click", (eMap) => polygonEventHandler(eMap) ) );
            setCallBackPolygonEventHandler(false);
        }

        return () => { isMounted = false };
    }, [isCallBackPolygonEventHandler])

    // Drawing Marker
    const [isDrawingManagerMarkers, setDrawingManagerMarkers] = useState([]);
    const markerEventHandler = (eMap) => {
        const ICON = {
            url: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            size: new window.google.maps.Size(20, 32),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(0, 32),
        };
        const SHAPE = {
            coords: [1, 1, 1, 20, 18, 20, 18, 1],
            type: "polygon",
        };

        const marker = new window.google.maps.Marker({
            position: eMap.latLng,
            map: isLoadMapInt,
            icon: ICON,
            shape: SHAPE,
            draggable: true,
            animation: window.google.maps.Animation.DROP,
            zIndex: 1,
        });

        setDrawingManagerMarkers(oldArray => [...oldArray, marker]);
    }

    // event reset drawing manager
    const [isResetDrawing, setResetDrawing] = useState(false);
    const onClickResetDrawingManager = () => {

        // set null drawing polygon
        if ( lands.length ) {
            lands.map((land) => {
                if ( land.instance ) {
                    land.instance.setMap(null);
                }
            });

            setLands([
                {
                    instance: null,
                    origin: null
                }
            ]);

            setLandIndex(0);
        }

        // set null drawing markers
        if ( isDrawingManagerMarkers.length ) {
            isDrawingManagerMarkers.map((item) => {
                item.setMap(null);
            })

            setDrawingManagerMarkers([]);
        }

        window.google.maps.event.removeListener(isListenerDrawingManager);
        setResetDrawing(true);

    }

    useEffect(() => {
        let isMounted = true;

        if ( isMounted && isResetDrawing ) {

            if ( isShapeType === MODE_POLYGON ) {
                // マーカー、区画を追加するイベントトリガー
                setListenerDrawingManager( window.google.maps.event.addListener(isLoadMapInt, "click", (eMap) => polygonEventHandler(eMap) ) );
            } else if ( isShapeType === MODE_MARKER ) {
                // マーカー、区画を追加するイベントトリガー
                setListenerDrawingManager( window.google.maps.event.addListener(isLoadMapInt, "click", (eMap) => markerEventHandler(eMap) ) )
            }

            setResetDrawing(false);

        }

        return () => { isMounted = false };
    }, [isResetDrawing])

    //drawingManager（追加）のポリゴンオプション
    const isStrokeColor = '#ff0000';
    const isStrokeWeight = 10;
    const isStrokeOpacity = 0.2;
    const [isRendererOptions, setRendererOptions] = useState({
        draggable: true,
        preserveViewport: false,
        markerOptions: true,
        polylineOptions: {
            strokeColor: isStrokeColor,
            strokeOpacity: isStrokeOpacity,
            strokeWeight: isStrokeWeight,
        },
    })
    const [isDirectionsRenderer, setDirectionsRenderer] = useState([]);
    const [isDirectionsEnd, setDirectionsEnd] = useState([
        {
            lat: 35.68377,
            lng: 139.69902000000002
        },
        {
            lat: 35.682454,
            lng: 139.698398
        }
    ])
    const [isPolyLinenArray, setPolyLinenArray] = useState([]);
    const onDirections = (map) => {
        console.log(isRendererOptions);
        const myLatLng = { lat: optionsMap.center.lat, lng: optionsMap.center.lng };
        const directionsServices = [];
        const directionsRenderers = [];
        const listDirectionsRenderer = [...isDirectionsRenderer];
        const listPolyLinen = [...isPolyLinenArray];
        isDirectionsEnd.map((item, index) => {
            //DirectionsService のオブジェクトを生成
            directionsServices[index] = new window.google.maps.DirectionsService();
            //DirectionsRenderer のオブジェクトを生成
            directionsRenderers[index] = new window.google.maps.DirectionsRenderer(isRendererOptions);
            // 経路のA、Bマーカを非表示
            directionsRenderers[index].setOptions(
                {suppressMarkers : true}
            );

            //directionsRenderer と地図を紐付け
            directionsRenderers[index].setMap(map);

            //リクエストの出発点の位置（Empire State Building 出発地点の緯度経度）
            const start = new window.google.maps.LatLng(myLatLng);
            //リクエストの終着点の位置（Grand Central Station 到着地点の緯度経度）
            const end = new window.google.maps.LatLng(item.lat, item.lng);
            // ルートを取得するリクエスト
            const request = {
                origin: start, // 出発地点の緯度経度
                destination: end, // 到着地点の緯度経度
                travelMode: "WALKING", //トラベルモード（歩き）
            };

            //DirectionsService のオブジェクトのメソッド route() にリクエストを渡し、
            //コールバック関数で結果を setDirections(result) で directionsRenderer にセットして表示
            directionsServices[index].route(request, function(result, status) {
                //ステータスがOKの場合、
                if (status === "OK") {
                    directionsRenderers[index].setDirections(result); //取得したルート（結果：result）をセット
                } else {
                    alert("取得できませんでした：" + status);
                }
            });

            let polyLinenArray;
            directionsRenderers[index].addListener('directions_changed', function() {
                polyLinenArray = [];
                const result = directionsRenderers[index].getDirections();

                result.routes[0].legs[0].steps.forEach((step) => {
                    step.path.forEach((point) => {
                        polyLinenArray.push({ Lat: point.lat(), Lng: point.lng() });
                    });
                });

                listPolyLinen[index] = polyLinenArray;

            });

            listDirectionsRenderer[index] = directionsRenderers[index];
        })

        // set state directions renderer
        setDirectionsRenderer(listDirectionsRenderer);
        setPolyLinenArray(listPolyLinen);
    }

    /* 詳細な駐車場マップ */
    const [isRendererOptionsChild, setRendererOptionsChild] = useState({
        draggable: false,
        preserveViewport: true,
        markerOptions: true,
        polylineOptions: {
            strokeColor: isStrokeColor,
            strokeOpacity: isStrokeOpacity,
            strokeWeight: isStrokeWeight,
        },
    })
    const [isDirectionsRendererChild, setDirectionsRendererChild] = useState([]);
    const [isDirectionsMapChild, setDirectionsMapChild] = useState([]);
    const onLoadMapParkingDetail = () => {
        const myLatLng = { lat: optionsMap.center.lat, lng: optionsMap.center.lng };
        const directionsServicesChild = [];
        const directionsRenderersChild = [];
        const listDirectionsRendererChild = [...isDirectionsRendererChild];
        const listDirectionsMapChild = [...isDirectionsMapChild];

        isDirectionsEnd.map((item, index) => {

            const mapParkingId = document.getElementById('map-parking-detail-' + index);
            const map = new window.google.maps.Map(mapParkingId, optionsMap);
            map.setCenter({ lat: item.lat, lng: item.lng });
            //DirectionsService のオブジェクトを生成
            directionsServicesChild[index] = new window.google.maps.DirectionsService();
            //DirectionsRenderer のオブジェクトを生成
            directionsRenderersChild[index] = new window.google.maps.DirectionsRenderer(isRendererOptionsChild);

            //directionsRenderer と地図を紐付け
            directionsRenderersChild[index].setMap(map);

            //リクエストの出発点の位置（Empire State Building 出発地点の緯度経度）
            const start = new window.google.maps.LatLng(myLatLng);
            //リクエストの終着点の位置（Grand Central Station 到着地点の緯度経度）
            const end = new window.google.maps.LatLng(item.lat, item.lng);
            // ルートを取得するリクエスト
            const request = {
                origin: start, // 出発地点の緯度経度
                destination: end, // 到着地点の緯度経度
                travelMode: "WALKING", //トラベルモード（歩き）
            };

            //DirectionsService のオブジェクトのメソッド route() にリクエストを渡し、
            //コールバック関数で結果を setDirections(result) で directionsRenderer にセットして表示
            directionsServicesChild[index].route(request, function(result, status) {
                //ステータスがOKの場合、
                if (status === "OK") {
                    directionsRenderersChild[index].setDirections(result);
                    directionsRenderersChild[index].setOptions({
                        draggable:false
                    });
                } else {
                    alert("取得できませんでした：" + status);
                }
            });

            listDirectionsRendererChild[index] = directionsRenderersChild[index];
            listDirectionsMapChild[index] = map;
        })

        // set state directions renderer
        setDirectionsRendererChild(listDirectionsRendererChild);
        setDirectionsMapChild(listDirectionsMapChild);
    }

    useEffect(() => {
        let isMounted = true;

        if ( isMounted && isDirectionsRendererChild ) {
            isDirectionsRenderer.map((item, index) => {
                isDirectionsRenderer[index].addListener('directions_changed', function() {
                    isDirectionsRendererChild[index].setDirections(isDirectionsRenderer[index].getDirections());
                });
            });
        }

        return () => { isMounted = false };
    },[isDirectionsRendererChild]);

    /* ロケーションエラーマップを処理する */
    const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? "Error: The Geolocation service failed."
                : "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(props.map);
    }

    /* event change select stroke attr */
    const onChangeStrokeAttr = (e) => {
        const { name, value } = e.currentTarget;

        if ( name === 'color' ) {
            isRendererOptions.polylineOptions.strokeColor = value;
            setRendererOptions({...isRendererOptions});

            isRendererOptionsChild.polylineOptions.strokeColor = value;
            setRendererOptionsChild({...isRendererOptionsChild});
        }

        if ( name === 'weight' ) {
            isRendererOptions.polylineOptions.strokeWeight = value;
            setRendererOptions({...isRendererOptions});

            isRendererOptionsChild.polylineOptions.strokeWeight = value;
            setRendererOptionsChild({...isRendererOptionsChild});
        }

        if ( name === 'opacity' ) {
            isRendererOptions.polylineOptions.strokeOpacity = value;
            setRendererOptions({...isRendererOptions});

            isRendererOptionsChild.polylineOptions.strokeOpacity = value;
            setRendererOptionsChild({...isRendererOptionsChild});
        }

    }

    useEffect(() => {
        let isMounted = true;

        if ( isMounted && isLoadMapInt ) {
            isDirectionsRenderer.map((item) => {
                item.setOptions(isRendererOptions);
                item.setMap(isLoadMapInt);
            });

            isDirectionsRendererChild.map((item, index) => {
                item.setOptions(isRendererOptionsChild);
                item.setMap(isDirectionsMapChild[index]);
            });
        }

        return () => { isMounted = false };
    },[isLoadMapInt, isRendererOptions]);

    /* event change memo list */
    const onHandleMemoChange = (e, index) => {
        const title = e.target.value;
        const list = [...isMemoList];

        list[index].title = title;
        setMemoList(list);

        onChangeMarkerMemo(index, title, list[index].lat, list[index].lng, isLoadMapInt);
    }

    /* event add new memo */
    const [isTotalMemo, setTotalMemo] = useState();
    const [isCompleteAddNewMemo, setCompleteAddNewMemo] = useState(false);

    useEffect(() => {
        let isMounted = true;

        if ( isMounted ) {
            setTotalMemo(isMemoList.length);

            if ( isCompleteAddNewMemo && isLoadMapInt ) {
                createMarkerMemoAddNew( isMemoList[isMemoList.length-1], isLoadMapInt );
                setCompleteAddNewMemo(false);
            }
        }

        return () => { isMounted = false };
    },[isLoadMapInt, isMemoList]);

    // create marker memo add new
    const createMarkerMemoAddNew = (newMemo, map) => {
        const infoWindowNewMemo = new window.google.maps.InfoWindow();
        const lat = newMemo.lat;
        const lng = newMemo.lng;

        const marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(lat, lng),
            draggable: true,
            map,
            icon: new window.google.maps.MarkerImage(
                "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
                new window.google.maps.Size(100, 100),
                new window.google.maps.Point(0, 0),
                new window.google.maps.Point(0, 33)
            ),
        });

        infoWindowNewMemo.setContent(newMemo.title);

        infoWindowNewMemo.open({
            anchor: marker,
            map,
            shouldFocus: false,
        });

        setMarkersMemo(oldArray => [...oldArray, marker]);
    }


    const onClickAddNewMemo = (count) => {
        if ( count <= 3 ) {
            setMemoList([...isMemoList, {
                title: 'メモを入力してください ',
                lat: 35.683772765981,
                lng: 139.6991517473873
            }]);

            setTotalMemo(count);
            setCompleteAddNewMemo(true);
        }
    }

    /* event delete memo */
    const onClickDeleteMemo = (index) => {
        const list = [...isMemoList];
        const markersMemoArr = [...isMarkersMemo];

        setCompleteAddNewMemo(false);

        markersMemoArr[index].setMap(null);
        markersMemoArr.splice(index, 1);

        list.splice(index, 1);
        setMemoList(list);
        setTotalMemo(isTotalMemo - 1);
        setMarkersMemo(markersMemoArr);
    }

    // 固定値での初期表示ポリゴン
    let monochromePathInti =
        "path=fillcolor:blue|weight:0|color:red|" +
        "35.683725901073245, 139.7003790669471|35.68366224248981, 139.70043728702308|35.683702256462475, 139.70049998556638|35.68376591501395, 139.7004283300883|35.683725901073245, 139.7003790669471";

    // 固定値での初期表示マーカー
    let markerInti_1 = isMarkerSrc;

    //staticで白黒地図にするためのパラメータ
    let monochromeStyle =
        "style=feature:water%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:water%7Celement:geometry.stroke%7Ccolor:0x000000&style=feature:landscape.natural%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:landscape.man_made%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:landscape.man_made%7Celement:geometry.stroke%7Ccolor:0x000000&style=feature:poi%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road.highway%7Csaturation:-100%7Clightness:50&style=feature:poi%7Celement:labels%7Cvisibility:off&style=feature:landscape.man_made%7Celement:labels.icon%7Cvisibility:off&style=feature:road%7Celement:geometry.stroke%7Ccolor:0x000000";

    const [isCopied, setCopied] = useState(false);

    const onHandleMonochromeMap = (faxUrl = false) => {
        //static実行後、マーカー、ポリゴンを初期化
        const monochromeMapSize = "size=640x480";
        let monochromeZoom;
        let monochromeCenter;
        let monochromeMarkers = "";
        let monochromePath = "";

        // 追加マーカーのURL設定
        isDrawingManagerMarkers.forEach((marker) => {
            monochromeMarkers = monochromeMarkers +
                "&markers=" +
                "icon:https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" +
                "|" +
                marker.getPosition().lat() +
                "," +
                marker.getPosition().lng();
        });

        // 初期表示マーカーのURL設定
        let markerInti =
            "markers=" +
            markerInti_1;

        isMemoList.forEach((itemMemo) => {
            const latLangMemo = [itemMemo.lat, itemMemo.lng];

            markerInti +=  "&" +
                "markers=" +
                "icon:https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png" +
                "|" + latLangMemo.toString();
        })

        // 追加ポリゴンのURL設定
        lands.map((land) => {
            monochromePath += "&path=fillcolor:blue|weight:0|color:red";

            if ( land.instance ) {
                const vertices = land.instance.getPath();

                for (let i = 0; i < vertices.getLength(); i++) {
                    const vertex = vertices.getAt(i);

                    monochromePath += "|" + vertex.lat() + "," + vertex.lng();
                }
            }
        });

        // 初期表示ポリゴンのURL設定
        monochromePathInti = "";
        isPolygons.forEach((Polygon, index) => {
            monochromePathInti += monochromePathInti + "&path=" + "fillcolor:blue|weight:0|color:red";

            isPolygonMarker[index].getPath().forEach((LatLng) => {
                monochromePathInti = monochromePathInti + "|" + LatLng.lat() + "," + LatLng.lng();
            });
        });

        // 経路図ルートURL設定
        const polylineOption = isRendererOptions.polylineOptions;

        //経路図ルートのポリライン座標
        let monochromePolyline = "";
        isPolyLinenArray.forEach((itemPolyLinen) => {
            monochromePolyline += "path=weight:" + polylineOption.strokeWeight + "|" +
                "color:" + polylineOption.strokeColor.replace("#", "0x") +
                parseInt(Number(polylineOption.strokeOpacity) * 255).toString(16);

            let paths = itemPolyLinen.map((point) => {
//                monochromePolyline += "|" + point.Lat + "," + point.Lng;
                return ([point.Lat,point.Lng])
            })
            monochromePolyline += "|enc:" + encode(paths)
            monochromePolyline += "&";
        });

        // 初期表示マップセンターのURL設定
        monochromeCenter = "center=" + isLoadMapInt.center.lat() + "," + isLoadMapInt.center.lng();
        // 初期表示マップズームのURL設定
        monochromeZoom = "zoom=" + isLoadMapInt.zoom;

        const staticUrl = "https://maps.googleapis.com/maps/api/staticmap?key=" +
            apiKey +
            "&" +
            monochromeMapSize +
            "&" +
            "scale=1&language=ja" +
            "&" +
            monochromeCenter +
            "&" +
            monochromeZoom +
            "&" +
            monochromePath +
            "&" +
            monochromePathInti +
            "&" +
            monochromeMarkers +
            "&" +
            markerInti +
            "&" +
            monochromePolyline +
            "&" +
            monochromeStyle

        if ( !faxUrl ) {
            window.open(
                staticUrl
            );
        } else {
            const el = document.createElement("input");

            el.value = staticUrl;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            setCopied(true);
        }

    }

    function encode(points) {
        var polypoint = '';
        var encodeNumber = function(num){  // 文字列変換
          var encodeString = '';
          while( num >= 0x20 ){            // ２進数５桁毎の処理
            encodeString +=(String.fromCharCode((0x20 | (num & 0x1f))+63));
            num >>= 5;                  
          }
          encodeString += (String.fromCharCode(num + 63)); // コードシフト
          return encodeString;
        };
        var encodeSignedNumber = function(num){
          var sgn_num = num << 1;          // １桁左シフト
          if( num < 0 ){
            sgn_num = ~(sgn_num);          // 負符号処理
          }
          return(encodeNumber(sgn_num));
        };
        var plat = 0; var plon = 0;  // 初期値設定
        for(let i=0; i<points.length; i++ ){
          var lat = parseFloat(points[i][0]);
          var lon = parseFloat(points[i][1]);
          var late5 = Math.floor(lat * 1e5);  // 有効桁数丸め
          var lone5 = Math.floor(lon * 1e5);  // 有効桁数丸め
          let dlat = late5 - plat;                // 差分値算出
          let dlon = lone5 - plon;                // 差分値算出
          plat = late5;                       // 前位置保存
          plon = lone5;                       // 前位置保存
          polypoint +=encodeSignedNumber(dlat) + encodeSignedNumber(dlon);
        }
        console.log(polypoint)
        return polypoint.replace(/\\/g,"\\\\"); // エスケープ符号対策
//        mapobj.fitBounds(bounds);        // 地図の中心とズームを調整
    };
    const changeParams = (e, feature, element, param) => {
        let mapStyles = isMapStyles
        mapStyles = mapStyles.map((style)=>{
            if (element == style.element && feature == style.feature) {
                if (param == "hue") {
                    style.params["hue"] = e.target.value
                }
                style.params[param] = e.target.value
            }
            return style
        })
        setMapStyles(mapStyles)
    }
    const showModal = () => {
        setModal(true)
    }

    useEffect(() => {
        const timeId = setTimeout(() => {
            setCopied(false);
        }, 1000)

        return () => {
            clearTimeout(timeId)
        }
    }, [isCopied]);

    return (<>
        <div className="parking-route">
            <div className="parking-route__info">
                <Row>
                    <Col lg="7">
                        <div id={idBoxMap} className="map-polygon" />
                    </Col>

                    <Col lg="5">
                        <div className="setting-map">
                            {/* 形状タイプ */}
                            <div className="setting-map__item">
                                <h4 className="title">
                                    形状タイプ
                                </h4>

                                <div className="group-box group-box-shape-type">
                                    <FormGroup check>
                                        <Input
                                            name="type"
                                            type="radio"
                                            id="type_none"
                                            value={MODE_GRAB}
                                            checked={isShapeType === MODE_GRAB}
                                            onChange={(e) => onChangeShapeType(e)}
                                        />

                                        <Label for="type_none" check>
                                            掴める
                                        </Label>
                                    </FormGroup>

                                    <FormGroup check>
                                        <Input
                                            name="type"
                                            type="radio"
                                            id="type_marker"
                                            value={MODE_MARKER}
                                            checked={isShapeType === MODE_MARKER}
                                            onChange={(e) => onChangeShapeType(e)}
                                        />

                                        <Label for="type_marker" check>
                                            マーカー編集
                                        </Label>
                                    </FormGroup>

                                    <FormGroup check>
                                        <Input
                                            name="type"
                                            type="radio"
                                            id="type_polygon"
                                            value={MODE_POLYGON}
                                            checked={isShapeType === MODE_POLYGON}
                                            onChange={(e) => onChangeShapeType(e)}
                                        />

                                        <Label for="type_polygon" check>
                                            図形編集
                                        </Label>
                                    </FormGroup>
                                </div>
                            </div>

                            {/* 経路の線の編集 */}
                            <div className="setting-map__item">
                                <h4 className="title">
                                    経路の線の編集
                                </h4>

                                <div className="group-box group-box-attr">
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <Label for="color">
                                                    色
                                                </Label>

                                                <div className="select-box">
                                                    <Input
                                                        id="color"
                                                        name="color"
                                                        type="select"
                                                        defaultValue={isStrokeColor}
                                                        onChange={(e) => onChangeStrokeAttr(e)}
                                                    >
                                                        {listSelectedColor.map((option) => (
                                                            <option value={option.value}>{option.label}</option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </FormGroup>
                                        </Col>

                                        <Col md="4">
                                            <FormGroup>
                                                <Label for="weight">
                                                    太さ
                                                </Label>

                                                <div className="select-box">
                                                    <Input
                                                        id="weight"
                                                        name="weight"
                                                        type="select"
                                                        defaultValue={isStrokeWeight}
                                                        onChange={(e) => onChangeStrokeAttr(e)}
                                                    >
                                                        {listSelectWeight.map((option) => (
                                                            <option value={option.value}>{option.label}</option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </FormGroup>
                                        </Col>

                                        <Col md="4">
                                            <FormGroup>
                                                <Label for="opacity">
                                                    透明度
                                                </Label>

                                                <div className="select-box">
                                                    <Input
                                                        id="opacity"
                                                        name="opacity"
                                                        type="select"
                                                        defaultValue={isStrokeOpacity}
                                                        onChange={(e) => onChangeStrokeAttr(e)}
                                                    >
                                                        {listSelectOpacity.map((option) => (
                                                            <option value={option.value}>{option.label}</option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            {/* 図形の描画 */}
                            <div className="setting-map__item">
                                <h4 className="title">
                                    図形の描画
                                </h4>

                                <div className="group-box">
                                    <Button
                                        color="primary"
                                        onClick={() => onClickAddPolygon()}
                                        disabled={isDisabledAddPolygon}
                                    >
                                        図形追加
                                    </Button>
                                    &emsp;
                                    <Button
                                        color="primary"
                                        onClick={() => onClickResetDrawingManager()}
                                    >
                                        リセット
                                    </Button>
                                </div>
                            </div>

                            {/* メモ欄の追加 */}
                            <div className="setting-map__item">
                                <h4 className="title">
                                    メモ欄の追加
                                </h4>

                                <div className="group-box mb-3">
                                    <Button
                                        color="primary"
                                        onClick={() => onClickAddNewMemo( isTotalMemo + 1 )}
                                    >
                                        メモ追加
                                    </Button>
                                </div>

                                <div className="group-memo">
                                    { isMemoList.map( (item, index) => {
                                        return (
                                            <FormGroup key={index}>
                                                <Label for={`memo-${index}`}>
                                                    メモ{index + 1}
                                                </Label>

                                                <Input
                                                    id={`memo-${index}`}
                                                    name={`memo-${index}`}
                                                    placeholder="メモを入力してください"
                                                    value={item.title}
                                                    onChange={(e) => onHandleMemoChange(e, index)}
                                                />

                                                <div className="delete" onClick={() => onClickDeleteMemo(index)}>
                                                    <img src={require("assets/img/icon-dust.jpeg")} alt=""/>
                                                </div>
                                            </FormGroup>
                                        )
                                    } ) }
                                </div>
                            </div>

                            <div className="setting-map__item">
                                <div className="group-box group-box-grid">
                                    <Button
                                        color="primary"
                                        onClick={()=> showModal()}
                                    >
                                        保存

                                    </Button>

                                    <Button
                                        color="primary"
                                        onClick={() => onHandleMonochromeMap()}
                                    >
                                        経路図プレビュー
                                    </Button>

                                    <Button
                                        color="primary"
                                        onClick={() => onHandleMonochromeMap(true)}
                                    >
                                        URL取得
                                    </Button>
                                </div>

                                <Alert color="info" isOpen={isCopied} >
                                    Copied!
                                </Alert>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="list-parking-detail mt-5">
                {isDirectionsRenderer && (
                    isDirectionsRenderer.map((item, index) => {
                        return (
                            <div className="list-parking-detail__item">
                                <h4 className="title">
                                    駐車場<span className="number">{index + 1}</span>
                                </h4>

                                <div className="detail-info">
                                    <Row>
                                        <Col lg="6">
                                            <div className="detail-info__table">
                                                <div className="item item-parking">
                                                    <div className="item__left">
                                                        <span>駐車場名</span>
                                                    </div>

                                                    <div className="item__right">
                                                        <span>乗泉寺駐車場</span>

                                                        <span>現場からの距離</span>

                                                        <span>18分</span>
                                                    </div>
                                                </div>

                                                <div className="item item-vehicle-size">
                                                    <div className="item__left">
                                                        <span>車両サイズ</span>
                                                    </div>

                                                    <div className="item__right text-center">
                                                        <span>ワゴン：</span>

                                                        <span>軽トラ：</span>

                                                        <span>2t：</span>
                                                    </div>
                                                </div>

                                                <div className="item item-daily-rate">
                                                    <div className="item__left">
                                                        <span>日割</span>
                                                    </div>

                                                    <div className="item__right">
                                                        <span>日割開始月：×</span>

                                                        <span>日割終了月：×</span>

                                                        <span>一月単位の計算：×</span>
                                                    </div>
                                                </div>

                                                <div className="item item-remarks">
                                                    <div className="item__left">
                                                        <span>特記事項</span>
                                                    </div>

                                                    <div className="item__right text-center">
                                                        <span>現在 1 台分空有</span>
                                                    </div>
                                                </div>

                                                <div className="item item-image">
                                                    <div className="box-img text-center">
                                                        <img src={require("assets/img/parking-image.png")} alt=""/>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col lg="6">
                                            <div id={`map-parking-detail-${index}`} className="detail-info__map"/>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
        <Modal isOpen={isModal} style={{backgroundColor:"white",width:"100vw",height:"100vh",margin:"0"}}>
            <Row style={{backgroundColor:"white",width:"80vw",margin:"auto"}}>
                <Col>
                    <Row>
                        <img src={createGoogleStaticMapUrl()}/>
                    </Row>
                    <Row>
                    <div>追加パラメータ</div>
                    <div>
                        <textarea name="editParams"id="editParams" onChange={(e)=>{setEditStyles(e.target.value)}}></textarea>
                    </div>
                    </Row>
                </Col>
                <Col>
                {isMapStyles.map((style)=>{
                return(<>
                <Row>
                    <Col>{style.feature} {style.element}</Col>
                    {style.params.color && (<>
                        <Col>
                            <Input
                                id={style.feature+style.element+"-color"}
                                name={style.feature+style.element+"-color"}
                                value={style.params.color}
                                onChange={(e) => changeParams(e, style.feature, style.element, "color")}
                            />
                        </Col>
                    </>)}
                    {style.params.weight && (<>
                        <Col>
                            <Input
                                id={style.feature+style.element+"-weight"}
                                name={style.feature+style.element+"-weight"}
                                value={style.params.weight}
                                onChange={(e) => changeParams(e, style.feature, style.element, "weight")}
                            />
                        </Col>
                    </>)}
                </Row>
                </>)
            })}
            <Button onClick={()=>{setModal(false)}}>
                閉じる
            </Button>
                </Col>
            </Row>
        </Modal>
    </>)

}



export default GoogleMapPolygon;